<mat-card >
    <mat-card-title *ngIf="caption && caption!==''">{{caption}}</mat-card-title>
    <mat-divider *ngIf="caption && caption!==''"></mat-divider>
    <mat-card-content class="card-content">
        <ng-container >
            <ng-content></ng-content>
        </ng-container>
    </mat-card-content>
</mat-card>
